import React, { Component } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { notification, message, Spin } from 'antd';


ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

export default class PorSurtimiento extends Component {
  
  state = {
    labels:[],
    values: [],
    loading: false
  }

  componentDidMount(){
    
    const { unidad_medica_user, periodo, backend } = this.props;

    fetch(`${backend}/porcentajeSurtimiento/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
      }).then((data) => {
        /// debugger
        //  console.log(data.data)
        let labels = [];
        let values = [];
        for (var i = 0; i < data.data.length; i++) {
            let row = data.data[i];
            if(row.value > 0){
                labels.push(row.name);
                values.push(row.value);
            }
        }
            this.setState({
                labels: labels,
                values: values,
                loading:true
            });
            // debugger
            this.getPercentage();
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener el porcentaje de surtimiento " + error,
          });
          message.destroy()
      });

  }

getPercentage = () => {
  let sum = 0;
  let percentageArr = [];
  let dataArr = this.state.values;
  dataArr.map(data => {
     sum += data;
  });
  dataArr.map(data => {
     let percentage = (data*100 / sum).toFixed(2);
     percentageArr.push(percentage);
  })
  // set state with percentage instead of values
    this.setState({
      values: percentageArr
    })
}

  render() {

    const { labels, values, loading } = this.state;

    const options = {
      responsive: true,
      maintainAspectRatio: false ,
      plugins: [ChartDataLabels],
      plugins: {
        legend: {
          position: 'bottom',
        },
        title:{
          display: true,
          text:'Porcentaje de Surtimiento',
          font:{
            size:'28'
          }
        },
        datalabels:{
          color: '#ffffff',
          font: {
            weight: 'bold',
            size: '15'
          },
            formatter: (value) => {
              return value + '%'
            }

        //   formatter: (value, context) => {
        //     // return context.dataIndex 
        //     let sum = 0;
        //     let dataArr = context.chart.data.datasets[0].data;
        //     dataArr.map(data => {
        //        sum += data;
        //     });
        //     let percentage = (value*100 / sum).toFixed(2)+"%";

        //     return context.chart.data.labels[context.dataIndex] + value + '\n' + percentage
        //     // return value
        //   }

        }
      },
    }

    const data = {
      // labels: ['Mujer', 'Hombre', 'Otro'],
      labels: labels,

      datasets: [
        {
          // label: '# of Votes',
          // data: [8,10, 1],
          data: values,
          backgroundColor: [
            'rgb(224, 4, 23, 1)',
            'rgb(51, 107, 255, 1)',
            'rgb(43, 203, 8, 1)',
            'rgba(248, 226, 14, 1)',
          ],
          borderColor: [
            'rgba(255, 255, 255, 1)'
          ],
          borderWidth: 1,
        },
      ],
    };

    return (
      loading ?
        <Pie 
        //   width={10}
        //   height={10 
         width={600}
          height={150}
          className="pieChart"
          data={data} 
          options={options} 
          plugins={'[ChartDataLabels]'}
        />      
        : <Spin size="small" />
    );
  }
}